export const CMUtils = {
    CodeMirror: undefined,
    publicResourceLoaded: undefined,
    modeMap: {
        xml: 'application/xml',
        java: 'text/x-java',
        vue: 'text/html',
        html: 'text/html',
        sql: 'text/x-sql',
    },
    get $lv() {
        return window.Vue.prototype.$lv
    },
    loadResource(dependencies) {
        return this.$lv.resource.load(dependencies.map(item => `/static/lib/${item}`))
    },
    async loadPublicResource() {
        if (this.publicResourceLoaded === undefined) {
            this.publicResourceLoaded = null;
            (async () => {
                await this.$lv.resource.loadLibPart('CodeMirror', [
                    'mode/xml/xml.js',
                    'mode/javascript/javascript.js',
                    'mode/clike/clike.js',
                    'mode/css/css.js',
                    'mode/sql/sql.js',
                    'mode/htmlmixed/htmlmixed.js',
                    'addon/selection/active-line.js',
                ])
                this.publicResourceLoaded = true;
            })()
            return await this.loadPublicResource()
        } else {
            while (this.publicResourceLoaded === null) {
                await this.$lv.$utils.delay(25)
            }
        }
        if (!this.publicResourceLoaded) {
            this.publicResourceLoaded = true
            await this.$lv.$utils.delay(23)
        }
    },
    async getCodeMirror() {
        if (this.CodeMirror === undefined) {
            this.CodeMirror = null
            this.loadCodeMirrorResource()
            return await this.getCodeMirror()
        } else {
            while (this.CodeMirror === null) {
                await this.$lv.$utils.delay(25)
            }
            return this.CodeMirror
        }
    },

    async loadCodeMirrorResource() {
        const [CodeMirror] = await Promise.all([this.$lv.resource.loadLib('CodeMirror'), this.$lv.resource.loadLibPart('CodeMirror', 'theme/monokai.css')])
        this.CodeMirror = CodeMirror
    },
}
